import React from 'react';
import useUser from '../hooks/useUser';
import ServerCompany from './server/Company';
import ClientCompany from './client/Company';

const Company = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    if (roleLower === 'client') {
        return <ClientCompany />;
    }
    return <ServerCompany />;
};

export default Company;
